import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgUserRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.688 13.688h-3.376a6.19 6.19 0 0 0-6.187 6.187c0 .621.504 1.125 1.125 1.125h13.5c.621 0 1.125-.504 1.125-1.125a6.19 6.19 0 0 0-6.187-6.187m-7.84 5.624a4.505 4.505 0 0 1 4.465-3.937h3.374c2.291 0 4.188 1.72 4.465 3.938zM12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m0-7.312A2.816 2.816 0 0 1 14.813 7.5 2.816 2.816 0 0 1 12 10.313 2.816 2.816 0 0 1 9.188 7.5 2.816 2.816 0 0 1 12 4.688"
    }));
export default SvgUserRegular;
